// extracted by mini-css-extract-plugin
export default {"BgtCountersWidget":"BgtCountersWidget_BgtCountersWidget__+D6la"};